import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

export const getRegisterLink = (club) => {
    if (club.acf?.register_link) {
        return club.acf.register_link;
    }
    if (club.excerpt) {
        return `https://gesthand.net/ihand-central/public/individu/inscription/${club.excerpt}?crtl=287bcb5be433c60f33f54cd1fac0191b6d067`;
    }
    return 'mailto:' + club.acf.email;
};

/**
 * Get FFH media URL
 *
 * @param {string} filename
 * @param {int|string} size - Must be 'original', 64, 128, 256 or 512
 */
export const getMediaUrl = (filename, size = 'original') => {
    return `https://media-logos-clubs.ffhandball.fr/${size}/${
        size === 'original' ? filename : filename.replace(/\.[^/.]+$/, '.webp')
    }`;
};

/**
 * Converts a given string to a camelCase slug.
 *
 * This function takes a string, removes all non-alphanumeric characters,
 * converts the string to lowercase, and then transforms it into camelCase format.
 *
 * @param {string} str - The input string to be converted.
 * @returns {string} - The camelCase version of the input string.
 */
export function stringToCamelCaseSlug(str) {
    return str
        .normalize('NFD') // Normalise la chaîne pour séparer les accents des caractères de base
        .replace(/[\u0300-\u036f]/g, '') // Supprime les diacritiques (accents)
        .toLowerCase() // Convertir tout en minuscules
        .replace(/[^a-z0-9]+/g, ' ') // Remplacer les caractères non alphanumériques par des espaces
        .trim() // Supprimer les espaces de début et de fin
        .split(' ') // Diviser en mots
        .map((word, index) => {
            if (index === 0) {
                return word; // Le premier mot reste en minuscule
            }
            return word.charAt(0).toUpperCase() + word.slice(1); // Capitaliser la première lettre des mots suivants
        })
        .join(''); // Joindre les mots pour former le slug en camelCase
}

/**
 * Vérifie si la start_date ou end_date est dans l'intervalle défini par la période sélectionnée.
 *
 * @param {('week'|'month'|'year'|undefined)} dateSelected - La période sélectionnée pour filtrer les dates (semaine, mois, année, ou undefined).
 * @param {string} [startDate] - La date de début de l'événement au format ISO (ex: '2023-09-04T12:00:00Z'). Peut être undefined si non disponible.
 * @param {string} [endDate] - La date de fin de l'événement au format ISO (ex: '2023-09-10T12:00:00Z'). Peut être undefined si non disponible.
 *
 * @returns {boolean} - Retourne `true` si la start_date ou end_date se trouve dans l'intervalle correspondant à la période sélectionnée, sinon `false`.
 *
 * Le filtre est basé sur la période :
 * - 'week' : La date doit être comprise entre maintenant et dans 1 semaine.
 * - 'month' : La date doit être comprise entre maintenant et dans 1 mois.
 * - 'year' : La date doit être comprise entre maintenant et dans 1 an.
 * Si aucune période (dateSelected) n'est spécifiée, la fonction retourne `true` par défaut.
 */
export const isDateWithinRange = (dateSelected, startDate, endDate) => {
    const now = dayjs();
    let rangeEnd;

    switch (dateSelected) {
        case 'week':
            rangeEnd = now.add(1, 'week');
            break;
        case 'month':
            rangeEnd = now.add(1, 'month');
            break;
        case 'year':
            rangeEnd = now.add(1, 'year');
            break;
        default:
            return true;
    }

    const start = startDate ? dayjs(startDate) : null;
    const end = endDate ? dayjs(endDate) : null;

    return (
        (start && start.isBetween(now, rangeEnd, null, '[]')) ||
        (end && end.isBetween(now, rangeEnd, null, '[]'))
    );
};
